import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import i18next from 'i18next';
import { Container, Grid, Box, Button, Hidden, IconButton, SvgIcon } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import Image from 'next/image';
import Link from './Link';
import MobileMenu from './MobileMenu';
import config from '../config';
import LangDropdown from './LangDropdown';
import { useRouter } from 'next/router';
import DropDownMenu from './DropDownMenu';
import useFeaturePages from 'hooks/useFeaturePages';
import useSolutionPages from 'hooks/useSolutionPages';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: 60,
    backgroundColor: '#ffffff',
    zIndex: 1000,
  },

  logo: {
    textDecoration: 'none',
    color: '#0f326c',
    fontSize: 18,
    fontWeight: 500,
  },
}));

const Menu = ({}) => {
  const classes = useStyles();
  const featurePages = useFeaturePages();
  const solutionPages = useSolutionPages();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const router = useRouter();
  const lang = router.query.lang || 'en';

  return (
    <Box pt={'6px'} className={classes.root}>
      <Container maxWidth="lg">
        <Grid container justifyContent={'space-between'} alignItems="center">
          <Grid item>
            <Grid container alignItems="center" justifyContent={'flex-start'} spacing={5}>
              <Grid item>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <a href={`/${lang}`} className={classes.logo}>
                      <Image
                        unoptimized={true}
                        src={'/logo.png'}
                        alt={i18next.t('meta.site_name', 'Doxer.io')}
                        width={40}
                        height={40}
                      />
                    </a>
                  </Grid>
                  <Hidden mdDown>
                    <Grid item>
                      <a href={`/${lang}`} className={classes.logo}>
                        Doxer.io
                      </a>
                    </Grid>
                  </Hidden>
                </Grid>
              </Grid>

              <Hidden mdDown>
                {lang === 'en' && (
                  <>
                    <Grid item>
                      <Link variant={'dark'} href={`/en/security`}>
                        Security
                      </Link>
                    </Grid>

                    <Grid item>
                      <DropDownMenu title={'Features'} pages={featurePages} />
                    </Grid>
                  </>
                )}

                <Grid item>
                  {lang === 'en' ? (
                    <DropDownMenu title={'Solutions'} pages={solutionPages} />
                  ) : (
                    <Link variant={'dark'} href={`/${lang}/#solutions`}>
                      {i18next.t('main_menu.solutions', 'Solutions')}
                    </Link>
                  )}
                </Grid>

                <Grid item>
                  <Link variant={'dark'} href={`/${lang}/contact`}>
                    {i18next.t('main_menu.contact', 'Contact')}
                  </Link>
                </Grid>

                <Grid item>
                  <Link variant={'dark'} href={`/${lang}/pricing`}>
                    {i18next.t('main_menu.pricing', 'Pricing')}
                  </Link>
                </Grid>

                <Grid item>
                  <Link variant={'dark'} href={`${config.appUrl}/login`}>
                    {i18next.t('main_menu.action.login', 'Login')}
                  </Link>
                </Grid>
              </Hidden>
            </Grid>
          </Grid>

          <Grid item>
            <Grid container alignItems="center" justifyContent={'flex-start'} spacing={6}>
              <Grid item>
                <Button
                  rel="opener"
                  href={`${config.appUrl}/register?utm_action_source=login_button`}
                  variant="outlined"
                  color="secondary">
                  {i18next.t('main_menu.action.signup', 'Signup for free')}
                </Button>
                {/*<Button rel="opener" href={`${config.appUrl}/login`} variant="outlined" color="secondary">*/}
              </Grid>

              <Hidden mdDown>
                <Grid item>
                  <LangDropdown lang={lang} />
                </Grid>
              </Hidden>
            </Grid>
          </Grid>

          <Hidden mdUp>
            <Grid item>
              <IconButton color="inherit" onClick={() => setMobileNavOpen(true)} size="large">
                <SvgIcon fontSize="small" style={{ color: 'inherit' }}>
                  <MenuIcon />
                </SvgIcon>
              </IconButton>
            </Grid>
          </Hidden>
        </Grid>

        <MobileMenu onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />
      </Container>
    </Box>
  );
};

Menu.propTypes = {};

Menu.defaultProps = {};

export default Menu;
